import { render, staticRenderFns } from "./BaseFontWeightSelect.vue?vue&type=template&id=bb3daf80&scoped=true"
import script from "./BaseFontWeightSelect.vue?vue&type=script&lang=js"
export * from "./BaseFontWeightSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3daf80",
  null
  
)

export default component.exports